export interface SearchFilters {
  type?: string
  schema?: string
  name?: string
  tag?: string
  // `is:archived` is a predicate ("show archived records"), not a scope
  // widener — it doesn't mean "also include archived alongside everything
  // else." Combined with other filters (e.g. `is:archived acme`), it narrows
  // to archived Acme records, not all Acme records.
  archivedOnly?: boolean
  isStructured: boolean
}

const KNOWN_KEYS = new Set(["is", "type", "schema", "name", "tag"])

// Tokenize input, keeping quoted strings as single tokens
// e.g. 'name:"John Smith" is:person' → ['name:"John Smith"', 'is:person']
const tokenize = (input: string): string[] => {
  const tokens: string[] = []
  let current = ""
  let inQuotes = false

  for (const char of input) {
    if (char === '"') {
      inQuotes = !inQuotes
      continue
    }
    if (/\s/.test(char) && !inQuotes) {
      if (current) tokens.push(current)
      current = ""
    } else {
      current += char
    }
  }
  if (current) tokens.push(current)
  return tokens
}

export const parseSearchQuery = (query: string): SearchFilters => {
  const tokens = tokenize(query)
  const plainWords: string[] = []
  let isStructured = false
  const filters: Record<string, string | boolean> = {}

  for (const token of tokens) {
    const colonIndex = token.indexOf(":")
    if (colonIndex > 0) {
      const key = token.substring(0, colonIndex).toLowerCase()
      const value = token.substring(colonIndex + 1).toLowerCase()
      if (!value) continue

      if (!KNOWN_KEYS.has(key)) continue

      isStructured = true
      if (key === "is" && value === "archived") {
        filters.archivedOnly = true
      } else if (key === "is" || key === "type") {
        filters.type = value
      } else if (key === "schema") {
        filters.schema = value
      } else if (key === "name") {
        filters.name = value
      } else if (key === "tag") {
        filters.tag = value
      }
    } else {
      plainWords.push(token.toLowerCase())
    }
  }

  if (plainWords.length > 0 && !filters.name) {
    filters.name = plainWords.join(" ")
  }

  return { ...filters, isStructured } as SearchFilters
}
